import React from 'react';
import type { Moneda } from '../../contexts/MonedaContext';

/**
 * Toggle de 3 monedas para la sección de Administración:
 *  ARS | USD (blue) | Const. (pesos constantes por UVA).
 * USD se deshabilita si no hay cotización blue; Const. si no hay UVA.
 */
const MonedaToggle: React.FC<{
  value: Moneda;
  onChange: (m: Moneda) => void;
  usdAvailable?: boolean;
  uvaAvailable?: boolean;
}> = ({ value, onChange, usdAvailable = true, uvaAvailable = true }) => {
  const opts: { v: Moneda; l: string; disabled?: boolean; title?: string }[] = [
    { v: 'ARS', l: 'ARS', title: 'Pesos nominales' },
    { v: 'USD', l: 'USD', disabled: !usdAvailable, title: !usdAvailable ? 'Dólar no disponible' : 'Dólar blue del día de cada operación' },
    { v: 'constante', l: 'Const.', disabled: !uvaAvailable, title: !uvaAvailable ? 'CER no disponible' : 'Pesos constantes: ajusta cada monto por inflación (CER) a su equivalente en pesos de hoy. Permite comparar valores de distintas fechas.' },
  ];
  return (
    <div className="inline-flex rounded-md border border-hairline bg-paper-2 p-0.5">
      {opts.map((o) => {
        const active = value === o.v;
        return (
          <button
            key={o.v}
            type="button"
            disabled={o.disabled}
            onClick={() => onChange(o.v)}
            title={o.title}
            className={`px-2.5 py-1 text-xs sm:text-sm font-medium rounded transition-colors ${
              active ? 'bg-forest text-white' : 'text-ink hover:bg-hairline/40'
            } ${o.disabled ? 'opacity-40 cursor-not-allowed' : ''}`}
          >
            {o.l}
          </button>
        );
      })}
    </div>
  );
};

export default MonedaToggle;
